import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ShareHolderType } from '../../../../../core';

@JsonConverter
export class ShareHolderTypeAdapter implements JsonCustomConvert<ShareHolderType | undefined> {
    serialize(type: ShareHolderType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): ShareHolderType | undefined {
        switch (type) {
            case 'Controller':
                return ShareHolderType.CONTROLLER;
            case 'Representative':
                return ShareHolderType.REPRESENTATIVE;
            case 'Shareholder':
                return ShareHolderType.SHAREHOLDER;
            default:
                return undefined;
        }
    }
}
